<template>
  <UiModalContainer
    v-if="showModal"
    :modal-show="showModal"
    :modal-width="100"
    parent-modal-class="container mx-auto "
    modal-classes="width-full"
    @handleClick="handleClick"
  >
    <template v-slot:header>
      <span class="sm:text-2.5xl text-lg font-poppins font-medium">
        Online Registrations and Enrollment
      </span>
    </template>
    <template v-slot>
      <div
        class="px-8 sm:px-10 md:px-12 lg:px-16 xl:px-17.5 showModal-body pt-8 pb-8 sm:pt-15 sm:pb-15 lg:pb-17.5"
      >
        <!-- Online Registrations and Enrollment -->
        <div class="">
          <Portal
            remove-classes="mx-0 px-0 "
            :image="require('@src/assets/images/HomePage/portal.png')"
            parent-class="sm:flex-row flex-col-reverse  "
            child-class=""
            image-class="mt-5 sm:pr-4 md:pr-8 lg:pr-12 xl:pr-15"
          >
            <div class="flex flex-col lg:my-auto xl:mt-2 flex-wrap gap-2.5 xl:gap-5">
              <DemoHeading
                text="Online Registrations and Enrollment"
               child-class="sm:ltr:text-2xl md:text-3xl xl:ltr:text-4.5xl xl:ltr:leading-60"
              />
              <Paragraph
                text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed dim nonumy eirmod tempor invidunt ut labore et dolore magna aam erat, sed diam voluptua. At vero eos et accusam et justo duo dos"
               child-class="xl:text-base lg:ltr:text-base"
              />
              <Paragraph
                text=" sanctus est Lorem ips dolor sit amet. Lorem ipsum dolor.Stet clita kasd gubergren, no sea takimata sanctus est Lorem ips dolor sit amet. Lorem ipsum dolor."
               child-class="xl:text-base lg:ltr:text-base"
              />
            </div>
          </Portal>
        </div>
        <!-- Keep Everyone In-Loop -->
        <div class="bg-white opacity-100 py-12.25 md:py-15 lg:py-25">
          <Portal
            remove-classes="mx-0 px-0"
            :image="require('@src/assets/images/HomePage/portal.png')"
            parent-class="flex-col-reverse sm:flex-row-reverse"
            child-class="sm:ltr:mt-0 "
            image-class="mt-5 pt-5 sm:pt-0 sm:pr-4 md:pr-8 lg:pr-12 xl:pr-15 img-flip"
          >
            <div class="flex flex-col lg:my-auto xl:mt-9 flex-wrap gap-2.5 xl:gap-5">
              <DemoHeading
                text="Keep Everyone In-Loop"
               child-class="sm:ltr:text-2xl md:text-3xl xl:ltr:text-4.5xl xl:ltr:leading-60"
              />
              <Paragraph
                text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliam erat, sed diam voluptua. At vero eos et accusam et justo duo lores et ea rebum. Stet clita kasd"
               child-class="xl:text-base lg:ltr:text-base"
              />
              <Paragraph
                text=" sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et"
               child-class="xl:text-base lg:ltr:text-base"
              />
            </div>
          </Portal>
        </div>
        <!-- Simplify and Excel -->
        <div class="text-center">
          <DemoHeading
            text="Simplify and Excel"
            class="mb-15 sm:ltr:text-2xl md:text-3xl xl:ltr:text-4.5xl xl:ltr:leading-60"
          />
          <div
            class="bg-dark-yellow-video h-64 xs:h-56 sm:h-80 md:h-96 xl:h-100 w-full rounded-3xl flex justify-center items-center"
          >
            <div class="cursor-pointer">
              <icon icon="play-btn" class="w-23 sm:w-28 xl:w-29" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </UiModalContainer>
</template>

<script>
import icon from '@src/components/icons/icon.vue'
import Portal from '@components/home-page/PortalSection.vue'
import UiModalContainer from '@src/components/UiElements/UiModalContainer.vue'
import DemoHeading from '@components/home-page/DemoSectionHeading.vue'
import Paragraph from '@components/home-page/DemoSectionParagarph.vue'
export default {
  components: {
    UiModalContainer,
    Portal,
    DemoHeading,
    Paragraph,
    icon,
  },
  props: {
    showDemoModal: { type: Boolean, default: false },
  },
  data() {
    return {
      showModal: false,
    }
  },
  watch: {
    showDemoModal: {
      immediate: true,
      handler(value) {
        this.showModal = value
      },
    },
  },
  methods: {
    handleClick(value) {
      if (value === 'close') return this.$emit('closeShowModal')
    },
    closeModal() {
      this.showModal = !this.showModal
      this.$emit('closeShowModal')
    },
  },
}
</script>

<style scoped></style>